export const nospenStyles = {
  inactiveOpacity: 0.5,
};
